import { createContext } from 'react';

export interface IAuthContext {
	currentToken: string | null;
}

export const AuthContext = createContext<IAuthContext>({
	currentToken: null,
});
